import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M41.371 35.73a1.03 1.03 0 0 0-.678-.828l-4.412-1.546c.15-.774.23-1.568.23-2.373v-.544h3.841a1.028 1.028 0 1 0 0-2.057h-3.84v-2.998l4.18-1.466a1.03 1.03 0 0 0 .68-.827l.82-5.854a1.029 1.029 0 0 0-2.037-.286l-.735 5.233-2.909 1.02v-3.192c0-.568-.46-1.029-1.028-1.029H34.16c-.333-3.262-2.24-6.058-4.94-7.638a3.84 3.84 0 0 1 3.796-3.287 1.029 1.029 0 0 0 0-2.057c-2.76 0-5.078 1.909-5.717 4.474a10 10 0 0 0-3.13-.507 10 10 0 0 0-3.301.569C20.25 7.94 17.918 6 15.135 6a1.029 1.029 0 0 0 0 2.057 3.845 3.845 0 0 1 3.812 3.392c-2.609 1.597-4.441 4.341-4.768 7.533h-1.323c-.567 0-1.028.46-1.028 1.029v3.192l-2.924-1.025-.86-5.251a1.027 1.027 0 1 0-2.03.333l.958 5.853c.062.372.32.68.675.805l4.18 1.466v2.998h-3.84a1.029 1.029 0 0 0 0 2.057h3.84v.544c0 .812.084 1.604.235 2.372l-4.415 1.548a1.03 1.03 0 0 0-.675.804l-.958 5.854a1.029 1.029 0 1 0 2.03.333l.86-5.252 3.73-1.308c1.765 4.661 6.264 7.99 11.536 7.99a12.25 12.25 0 0 0 8.716-3.624 12.35 12.35 0 0 0 2.82-4.366l3.714 1.302.735 5.234a1.029 1.029 0 0 0 2.037-.286zM24.17 12.025c4.055 0 7.414 3.037 7.92 6.957H16.25c.506-3.92 3.865-6.957 7.92-6.957M13.885 30.983v-9.944h9.256v20.176c-5.19-.517-9.256-4.909-9.256-10.232m20.569 0a10.2 10.2 0 0 1-3.022 7.262 10.22 10.22 0 0 1-6.233 2.97V21.04h9.255z",
      clipRule: "evenodd"
    }
  )
);
var SvgBugOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BugOutlined_default = SvgBugOutlined;

export { BugOutlined_default as default };
